import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [5.48129294297],
    [0.09260408234, 0.89106421507, 74.7815985673],
    [0.01504247898, 3.6271926092, 1.4844727083],
    [0.00365981674, 1.89962179044, 73.297125859],
    [0.00272328168, 3.35823706307, 149.5631971346],
    [0.00070328461, 5.39254450063, 63.7358983034],
    [0.00068892678, 6.09292483287, 76.2660712756],
    [0.00061998615, 2.26952066061, 2.9689454166],
    [0.00061950719, 2.85098872691, 11.0457002639],
    [0.0002646877, 3.14152083966, 71.8126531507],
    [0.00025710476, 6.11379840493, 454.9093665273],
    [0.0002107885, 4.36059339067, 148.0787244263],
    [0.00017818647, 1.74436930289, 36.6485629295],
    [0.00014613507, 4.73732166022, 3.9321532631],
    [0.00011162509, 5.8268179635, 224.3447957019],
    [0.0001099791, 0.48865004018, 138.5174968707],
    [0.00009527478, 2.95516862826, 35.1640902212],
    [0.00007545601, 5.236265824, 109.9456887885],
    [0.00004220241, 3.23328220918, 70.8494453042],
    [0.000040519, 2.277550173, 151.0476698429],
    [0.0000349034, 5.48306144511, 146.594251718],
    [0.00003354596, 1.0654900738, 4.4534181249],
    [0.00003144069, 4.75199570434, 77.7505439839],
    [0.00002926718, 4.62903718891, 9.5612275556],
    [0.00002922333, 5.35235361027, 85.8272988312],
    [0.00002272788, 4.36600400036, 70.3281804424],
    [0.00002148602, 0.60745949945, 38.1330356378],
    [0.00002051219, 1.51773566586, 0.1118745846],
    [0.00001991643, 4.92437588682, 277.0349937414],
    [0.00001666902, 3.62744066769, 380.12776796],
    [0.00001533221, 2.58594681212, 52.6901980395],
    [0.00001376226, 2.04283539351, 65.2203710117],
    [0.00001372139, 4.19641530878, 111.4301614968],
    [0.00001284107, 3.11347961505, 202.2533951741],
    [0.00001281604, 0.54271272721, 222.8603229936],
    [0.00001244347, 0.91614441731, 2.4476805548],
    [0.00001221029, 0.1990065003, 108.4612160802],
    [0.00001150989, 4.17898916639, 33.6796175129],
    [0.00001150429, 0.93343589092, 3.1813937377],
    [0.00001090463, 1.77501500531, 12.5301729722],
    [0.00001072013, 0.23566016888, 62.2514255951],
    [0.00000946181, 1.19253165736, 127.4717966068],
];

const VSOP87_L1: Vsop87Element = [
    [74.7815986091],
    [0.00154332863, 5.24158770553, 74.7815985673],
    [0.00024456474, 1.71260334156, 1.4844727083],
    [0.00009258442, 0.4282973235, 11.0457002639],
    [0.0000915016, 1.41213765216, 149.5631971346],
    [0.00008265977, 1.50218091379, 63.7358983034],
    [0.00003899108, 0.4648357916, 3.9321532631],
    [0.00002277065, 4.17199181523, 76.2660712756],
    [0.0000192747, 0.52976188479, 2.9689454166],
    [0.00001232725, 1.58632088145, 70.8494453042],
    [0.00000791201, 5.43640595978, 3.1813937377],
    [0.00000766954, 1.99425624214, 73.297125859],
    [0.00000565091, 3.87400932383, 224.3447957019],
    [0.00000481813, 2.98574070918, 85.8272988312],
    [0.00000449635, 4.14242946378, 138.5174968707],
    [0.000004266, 4.73158166033, 71.8126531507],
    [0.00000347745, 2.45368882357, 9.5612275556],
    [0.00000332699, 2.55525645638, 148.0787244263],
    [0.00000317054, 5.57858240166, 52.6901980395],
    [0.00000205579, 2.36242761009, 2.4476805548],
    [0.00000202696, 0.34360451816, 151.0476698429],
    [0.0000018909, 4.20258063269, 56.6223513026],
    [0.00000179897, 5.68365861477, 12.5301729722],
];

const VSOP87_L2: Vsop87Element = [
    [0.00002349469, 2.26708640433, 74.7815985673],
    [0.00000768983, 4.52562378749, 11.0457002639],
    [0.00000551555, 3.2581932204, 63.7358983034],
    [0.00000541559, 2.27572631399, 3.9321532631],
    [0.00000529491, 4.92336172394, 1.4844727083],
    [0.00000257527, 3.69060540044, 3.1813937377],
    [0.00000184429, 5.05954505833, 149.5631971346],
    [0.00000182036, 6.21866555925, 70.8494453042],
    [0.00000053456, 1.45801353517, 76.2660712756],
    [0.00000049505, 6.03085160423, 56.6223513026],
    [0.00000044885, 3.90644983662, 2.4476805548],
    [0.00000044623, 0.81232539761, 85.8272988312],
    [0.00000038334, 1.78433163102, 52.6901980395],
    [0.00000037373, 4.46132739805, 2.9689454166],
    [0.00000033044, 0.86461989031, 9.5612275556],
    [0.0000002925, 5.09724793503, 73.297125859],
    [0.00000024305, 2.10670976428, 18.1592472647],
];

const VSOP87_L3: Vsop87Element = [
    [0.00000122192, 0.02112102225, 74.7815985673],
    [0.00000068195, 4.12138633187, 3.9321532631],
    [0.00000052729, 2.38808499397, 11.0457002639],
    [0.00000045405, 2.04405402149, 3.1813937377],
    [0.00000043714, 2.95937380925, 1.4844727083],
    [0.00000024903, 4.886800756, 63.7358983034],
    [0.00000021004, 4.54879176205, 70.8494453042],
    [0.00000010361],
];

const VSOP87_L4: Vsop87Element = [
    [0.00000005536, 4.57721551627, 74.7815985673],
    [0.00000003183, 0.34467460171, 11.0457002639],
];

const VSOP87_L5: Vsop87Element = [];

const VSOP87_B0: Vsop87Element = [
    [0.01346277648, 2.61877810547, 74.7815985673],
    [0.000623414, 5.08111189648, 149.5631971346],
    [0.00009963722, 1.61603805646, 76.2660712756],
    [0.0000992616, 0.57630380333, 73.297125859],
    [0.00003259466, 1.26119342526, 224.3447957019],
    [0.00002972303, 2.24367206357, 1.4844727083],
    [0.00002010275, 6.05550884547, 148.0787244263],
    [0.00001522163, 0.27959645002, 63.7358983034],
    [0.00000924064, 4.03822512696, 151.0476698429],
    [0.0000076064, 6.13999362624, 71.8126531507],
    [0.00000522314, 3.32086440954, 138.5174968707],
    [0.0000046263, 0.74256687606, 85.8272988312],
    [0.00000436847, 3.38081057022, 529.6909650946],
    [0.00000434627, 0.34063199763, 77.7505439839],
    [0.00000430661, 3.55443947716, 213.299095438],
    [0.00000420265, 5.21280055515, 11.0457002639],
    [0.00000244698, 0.787951741, 2.9689454166],
    [0.00000232667, 2.25715668168, 222.8603229936],
];

const VSOP87_B1: Vsop87Element = [
    [0.00034101978, 0.01321929936, 74.7815985673],
    [0.00002480115, 2.73961370453, 149.5631971346],
    [0.00001719377],
    [0.00000395276, 5.49322816551, 76.2660712756],
    [0.00000308903, 3.61139770633, 73.297125859],
    [0.00000181125, 5.32079457105, 224.3447957019],
    [0.0000014452, 4.22110521671, 63.7358983034],
    [0.00000076343, 4.54620999213, 85.8272988312],
    [0.00000072633, 5.97811706013, 1.4844727083],
    [0.00000065492, 2.77607065171, 11.0457002639],
    [0.00000063931, 6.15917217447, 138.5174968707],
    [0.00000050972, 1.79457572126, 151.0476698429],
];

const VSOP87_B2: Vsop87Element = [
    [0.00000764663, 1.74870957857, 74.7815985673],
    [0.00000025641, 5.67301557131, 149.5631971346],
    [0.00000013335, 5.92348443969, 73.297125859],
    [0.00000006636, 2.30241577514, 85.8272988312],
    [0.00000004926, 2.21241492976, 76.2660712756],
    [0.00000004368, 0.76649493506, 11.0457002639],
    [0.00000004095, 1.81604424547, 70.8494453042],
];

const VSOP87_B3: Vsop87Element = [
    [0.00000021201, 3.16540759295, 74.7815985673],
    [0.00000001182, 4.44441014271, 149.5631971346],
    [0.00000000466, 5.92951996029, 70.8494453042],
];

const VSOP87_B4: Vsop87Element = [];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [19.21264847206],
    [0.88784984413, 5.60377527014, 74.7815985673],
    [0.03440836062, 0.32836099706, 73.297125859],
    [0.0205565386, 1.7829515933, 149.5631971346],
    [0.0064932241, 4.52247285911, 76.2660712756],
    [0.00602247865, 3.86003823674, 63.7358983034],
    [0.00496404167, 1.40139935333, 454.9093665273],
    [0.00338525369, 1.58002770318, 138.5174968707],
    [0.00243509114, 1.57086606044, 71.8126531507],
    [0.00190522303, 1.99809394714, 1.4844727083],
    [0.00161858838, 2.79137786799, 148.0787244263],
    [0.00143706183, 1.38368544947, 11.0457002639],
    [0.00093192405, 0.17437220467, 36.6485629295],
    [0.00089806014, 3.66105364565, 109.9456887885],
    [0.00071424548, 4.24509236074, 224.3447957019],
    [0.00046677296, 1.39976401694, 35.1640902212],
    [0.00039025624, 3.36234773834, 277.0349937414],
    [0.00039009723, 1.66971401684, 70.8494453042],
    [0.00036755274, 3.88649278513, 146.594251718],
    [0.00030348723, 0.70100838798, 151.0476698429],
    [0.00029156413, 3.180563367, 77.7505439839],
    [0.0002578588, 3.7853770987, 85.8272988312],
    [0.00025620756, 5.25656086672, 380.12776796],
    [0.00022637073, 0.72518687029, 529.6909650946],
    [0.00020473534, 2.79640244248, 70.3281804424],
    [0.00020471591, 1.55587964879, 202.2533951741],
    [0.000179013, 0.55455066863, 2.9689454166],
    [0.00015502375, 5.35405396163, 38.1330356378],
    [0.00014701666, 4.90434516516, 108.4612160802],
    [0.00012896452, 2.62154084288, 111.4301614968],
    [0.00012328114, 5.96037276805, 127.4717966068],
    [0.00011959076, 1.7504339214, 984.6003316219],
    [0.00011852959, 0.99344161196, 52.6901980395],
    [0.00011695693, 3.29824190199, 3.9321532631],
    [0.0001149468, 0.43772043395, 65.2203710117],
    [0.00010792498, 1.42106296264, 213.299095438],
    [0.00009111621, 4.99633582839, 62.2514255951],
    [0.00008420792, 5.25351368389, 222.8603229936],
    [0.00008402384, 5.03876467031, 415.5524906121],
    [0.00007448995, 0.79495503123, 351.8165923087],
    [0.00007329301, 3.97276588872, 183.2428146475],
    [0.00006046221, 5.67958564987, 78.7137518304],
    [0.00005524411, 3.11493320824, 9.5612275556],
];

const VSOP87_R1: Vsop87Element = [
    [0.01479896629, 3.67205697578, 74.7815985673],
    [0.00071212143, 6.22600975161, 63.7358983034],
    [0.0006862716, 6.13411179902, 149.5631971346],
    [0.00021468362, 2.60175716374, 76.2660712756],
    [0.00020857554, 5.2462584896, 11.0457002639],
    [0.00011405056, 0.01849738017, 70.8494453042],
    [0.00007496797, 0.42361355955, 73.297125859],
    [0.00004243606, 1.41691058162, 85.8272988312],
    [0.00003926833, 3.15526349399, 71.8126531507],
    [0.00003578254, 2.31157935775, 224.3447957019],
    [0.00003505951, 2.58348117401, 138.5174968707],
    [0.000032288, 5.25495561645, 3.9321532631],
    [0.00003059899, 0.15323842112, 1.4844727083],
    [0.00002564235, 0.98078549108, 148.0787244263],
    [0.00002429191, 3.99450740432, 52.6901980395],
    [0.0000164483, 2.65310351864, 127.4717966068],
    [0.00001583569, 1.4304953436, 78.7137518304],
    [0.00001507836, 5.06019185241, 151.0476698429],
    [0.00001489724, 2.67568435302, 56.6223513026],
    [0.0000141338, 4.57461623347, 202.2533951741],
    [0.0000140328, 1.36986207457, 77.7505439839],
    [0.00001227894, 1.04699377171, 62.2514255951],
    [0.00001032728, 0.26473484111, 131.4039498699],
    [0.00000991944, 2.1718165585, 65.2203710117],
    [0.00000861752, 5.05508815872, 351.8165923087],
    [0.00000744512, 3.07725212553, 35.1640902212],
    [0.00000687477, 2.49910872963, 77.962992305],
    [0.00000647014, 4.47286717163, 70.3281804424],
    [0.00000623247, 0.86227007749, 9.5612275556],
    [0.00000603966, 0.90716451094, 984.6003316219],
];

const VSOP87_R2: Vsop87Element = [
    [0.00022439899, 0.69953310903, 74.7815985673],
    [0.00004726838, 1.69896897296, 63.7358983034],
    [0.00001681383, 4.64842242588, 70.8494453042],
    [0.00001649477, 3.09669484042, 11.0457002639],
    [0.00001433633, 3.52135281258, 149.5631971346],
    [0.00000769974],
    [0.00000500193, 6.17218448634, 76.2660712756],
    [0.00000461159, 0.76667185672, 3.9321532631],
    [0.00000390377, 4.49603136758, 56.6223513026],
    [0.00000389972, 5.52663268311, 85.8272988312],
    [0.00000292283, 0.20370820668, 52.6901980395],
    [0.00000286451, 3.53449822561, 73.297125859],
    [0.00000272269, 3.8473537521, 138.5174968707],
    [0.00000219349, 1.96433948894, 131.4039498699],
    [0.00000215812, 0.84820922453, 77.962992305],
    [0.00000205341, 3.24759155116, 78.7137518304],
    [0.00000148716, 4.89757177249, 127.4717966068],
];

const VSOP87_R3: Vsop87Element = [
    [0.00001164663, 4.73440180792, 74.7815985673],
    [0.00000212363, 3.34268349684, 63.7358983034],
    [0.00000196315, 2.981012371, 70.8494453042],
    [0.00000104707, 0.95789279555, 11.0457002639],
    [0.00000072719, 0.99479831041, 149.5631971346],
    [0.00000071681, 0.02528295071, 56.6223513026],
];

const VSOP87_R4: Vsop87Element = [[0.00000053224, 3.00468894529, 74.7815985673]];

const VSOP87_R5: Vsop87Element = [];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
